
define('app/dashboard/leagues/instances/views/draftOrderView',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/collections/pickCollection',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/leagueUserModel',
	'known/models/fantasyTeamModel',
	'app/board/models/pickModel',
	
	//Templates
	'text!app/dashboard/leagues/instances/templates/draftOrderAddPickTemplate.html',
	'text!app/dashboard/leagues/instances/templates/draftOrderPickTemplate.html'
], function(
		$, 
		_, 
		Backbone, 
		PickCollection,
		UserModel, 
		LeagueInstanceModel,
		LeagueUserModel,
		FantasyTeamModel,
		PickModel,
		addPickHtml,
		pickHtml){
	
	var DraftOrderFooterView = Backbone.View.extend({
		events: {
			'click #savePicksBtn': 'submitSavePicksForm',
			'click #undoPicksBtn': 'submitUndoPicksForm'
		},
		
		initialize: function(options) {
			this.pickCollection = options.pickCollection;
			this.event = options.event;
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			
			//this.listenTo(this.event, 'default', this.showEditForm);
			this.listenTo(this.pickCollection, 'reset', this.reset);
			this.listenTo(this.pickCollection, 'change ', this.showChangedPicksForm);
			this.listenTo(this.pickCollection, 'remove', this.showChangedPicksForm);
			this.listenTo(this.pickCollection, 'add', this.showChangedPicksForm);
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'processing', this.hideAll);
			this.listenTo(this.event, 'error', this.showForm);
			this.listenTo(this.event, 'success', this.showForm);
		},
		
		render: function() {
			this.hideAll();
			
			return this;
		},
		
		hideAll: function () {
			$(this.el).hide();
			this.$("#savePicksBtn").hide();
			this.$("#undoPicksBtn").hide();
			this.$("#savePicksNotSavedMessage").hide();
			this.$("#savePicksSavedMessage").show();			
		},
		
		showForm: function() {
			this.hideAll();
			
			if(this.lgInstance.isCommissioner(this.userModel.get('userName')) 
					&& this.lgInstance.get('draftType') == 'CUSTOM'
					&& this.lgInstance.get('draftStatus') != "COMPLETED"){
				$(this.el).show();
			}
		},
		
		reset: function () {
			this.$("#savePicksBtn").hide();
			this.$("#undoPicksBtn").hide();
			this.$("#savePicksNotSavedMessage").hide();
			this.$("#savePicksSavedMessage").show();			
		},
		
		submitSavePicksForm: function () {
			this.event.trigger("savePicks");
		},
		
		submitUndoPicksForm: function () {
			this.event.trigger("undoPicks");
		},
		
		showChangedPicksForm: function () {
			this.reset();
			this.$("#savePicksBtn").show();
			this.$("#undoPicksBtn").show();
			this.$("#savePicksNotSavedMessage").show();
			this.$("#savePicksSavedMessage").hide();
		}
	});
	
	var DraftOrderSummaryView = Backbone.View.extend({		
		initialize: function(options) {
			this.event = options.event;
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.pickCollection = options.pickCollection;
			
			this.tableBodyEl = this.$("#draftOrderSummaryTableBody");
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'processing', this.hideAll);
			this.listenTo(this.event, 'error', this.showForm);
			this.listenTo(this.event, 'success', this.showForm);
			
			this.listenTo(this.pickCollection, 'reset', this.generateSummary);
			this.listenTo(this.pickCollection, 'change', this.generateSummary);
			this.listenTo(this.pickCollection, 'add', this.generateSummary);
			this.listenTo(this.pickCollection, 'remove', this.generateSummary);
		},
		
		render: function () {			
			this.generateSummary();
			return this;
		},
		
		generateSummary: function() {
			var teamList = this.lgInstance.getTeamList();
			this.pickCount = {};
			this.commonCount = 0;
			this.allSameCount = true;
			
			_.each(teamList, function(team){
				this.pickCount[team.get('id')] = 0;
			}, this);
			
			this.pickCollection.each(function(pick) {
				if(pick.get('posInRound') && pick.get('fantasyTeamId') && pick.get('posInRound') > 0 && pick.get('fantasyTeamId') > 0){
					this.pickCount[pick.get('fantasyTeamId')] = this.pickCount[pick.get('fantasyTeamId')] + 1;
				}
			}, this);
			
			_.each(teamList, function(team){
				if(this.commonCount == 0){
					this.commonCount = this.pickCount[team.get('id')]; 
				} else if(this.pickCount[team.get('id')] != this.commonCount){
					this.allSameCount = false;
				}
			}, this);
			
			if(this.allSameCount){
				this.$("#draftOrderEvenPickNum").html(this.commonCount);
				this.$("#draftOrderSummaryUnevenPicks").hide();
				this.$("#draftOrderSummaryContainer").hide();
				this.$("#draftOrderSummaryEvenPicks").show();
			} else {
				this.$("#draftOrderSummaryEvenPicks").hide();
				this.$("#draftOrderSummaryUnevenPicks").show();
				
				this.tableBodyEl.empty();
				
				_.each(teamList, function(team){
					var el = $('<tr><td>'+team.get('draftPosition')+'</td><td>'+team.get('teamName')+'</td><td>'+this.pickCount[team.get('id')]+'</td></tr>');
					
					this.tableBodyEl.append(el);
				}, this);
				
				this.$("#draftOrderSummaryContainer").show();
			}
			
			delete this.pickCount;
			delete this.commonCount;
			delete this.allSameCount;
		},
		
		hideAll: function () {
			$(this.el).hide();			
		},
		
		showForm: function() {
			this.hideAll();
			
			if(this.lgInstance.isCommissioner(this.userModel.get('userName')) && this.lgInstance.get('draftType') == 'CUSTOM'){
				$(this.el).show();
			}
		},
		
		submitResetForm: function () {
			if(this.$(".draftOrderResetSelInput").val() && this.$(".draftOrderResetSelInput").val() != ""){
				this.event.trigger("resetPicks", this.$(".draftOrderResetSelInput").val());
			}
		},
	});
	
	var DraftOrderResetView = Backbone.View.extend({
		events: {
			'click #resetPicksBtn': 'submitResetForm'
		},
		
		initialize: function(options) {
			this.event = options.event;
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'processing', this.hideAll);
			this.listenTo(this.event, 'error', this.showForm);
			this.listenTo(this.event, 'success', this.showForm);
		},
		
		render: function () {			
			return this;
		},
		
		hideAll: function () {
			$(this.el).hide();			
		},
		
		showForm: function() {
			this.hideAll();
			
			if(this.lgInstance.isCommissioner(this.userModel.get('userName')) 
					&& this.lgInstance.get('draftType') == 'CUSTOM'
					&& this.lgInstance.get('draftStatus') == "SETUP"){
				$(this.el).show();
			}
		},
		
		submitResetForm: function () {
			if(this.$(".draftOrderResetSelInput").val() && this.$(".draftOrderResetSelInput").val() != ""){
				this.event.trigger("resetPicks", this.$(".draftOrderResetSelInput").val());
			}
		},
	});
	
	var DraftOrderRoundView = Backbone.View.extend({
		initialize: function(options) {
			this.lgInstance = options.lgInstance;
			this.event = options.event;
			
			_.bindAll(this, 'changeRound');
			
			this.$(".draftOrderRoundSelInput").on('change', this.changeRound);
			
			this.listenTo(this.lgInstance, 'change', this.updateVisuals);
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'processing', this.hideAll);
			this.listenTo(this.event, 'error', this.showForm);
			this.listenTo(this.event, 'success', this.showForm);
		},
		
		render: function () {
			this.updateVisuals();
			return this;
		},
		
		hideAll: function () {
			$(this.el).hide();			
		},
		
		showForm: function() {
			this.hideAll();
			
			$(this.el).show();
		},
		
		changeRound: function() {
			this.event.trigger("changeRound");
		},
		
		updateVisuals: function() {
			var numRounds = this.lgInstance.get("numRounds");		
			
			var optionStart = "<option value=\"";
			var optionMiddle = "\" >";
			var optionEnd = "</option>";
			
			this.$(".draftOrderRoundSelInput").empty();
			
			for(var i=1; i <= numRounds; i++) {
				var selected = "";
				
				if(i == 1){
					selected = "\" selected=\"true";
				}
				
				this.$(".draftOrderRoundSelInput").append(optionStart 
						+ i
						+ selected
						+ optionMiddle
						+ i						
						+ optionEnd);
			}
			
			$(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});
		}
	});
	
	var DraftOrderMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'processing', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$("#draftOrderMessageError").hide();
			this.$("#draftOrderMessageProcessing").hide();
			this.$("#draftOrderMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#draftOrderMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#draftOrderMessageSuccess").show();
			$(this.el).fadeOut(3000);
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#draftOrderMessageProcessing").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	var DraftOrderListFakeItemView = Backbone.View.extend({
		initialize: function(options) {
			this.event = options.event;
			this.position = options.position;
			this.round = options.round;
			this.lgInstance = options.lgInstance;
			
			if(this.lgInstance.get('draftType') == 'SNAKE' && this.round % 2 == 0){
				this.team = this.lgInstance.getTeamByDraftPosition((this.lgInstance.numTeams() - this.position) + 1);
			} else {
				this.team = this.lgInstance.getTeamByDraftPosition(this.position);
			}			
			
			this.pickTemplate = _.template(pickHtml.trim());
			
			this.buildEl();
		},
		
		render: function () {
			
			return this;
		},
		
		buildEl: function() {
			this.setElement($(this.pickTemplate({
				round: this.round,
				position: this.position,
				teamName: this.team.get('teamName'),
				teamPosition: this.team.get('draftPosition')})));
			this.$(".draftOrderTmSelInput").hide();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	$(this.el).removeData().unbind();
	    	this.remove();  
	    	Backbone.View.prototype.remove.call(this);
        }
	});
	
	var DraftOrderListItemView = Backbone.View.extend({
		initialize: function(options) {
			this.lgInstance = options.lgInstance;
			this.pick = options.pick;
			this.event = options.event;
			this.position = options.position;			
			this.team = this.lgInstance.getTeam(this.pick.get('fantasyTeamId'));
			
			_.bindAll(this, 'changeTeam');
			_.bindAll(this, 'deletePick');			
			
			this.pickTemplate = _.template(pickHtml.trim());
			
			this.buildEl();
			
			this.$(".draftOrderTmSelInput").on('change', this.changeTeam);
			this.$(".removePickBtn").on('click', this.deletePick);
		},
		
		render: function () {
			
			return this;
		},
		
		buildEl: function() {
			this.setElement($(this.pickTemplate({
				round: this.pick.get('round'),
				position: this.position,
				teamName: this.team.get('teamName'),
				teamPosition: this.team.get('draftPosition')})));
			
			if(this.lgInstance.get('draftStatus') != "SETUP"){
				this.$(".removePickBtn").hide();
			}
			
			this.populateTeamDropdown();
		},
		
		populateTeamDropdown: function () {
			var teams = this.lgInstance.getTeamList();		
			
			this.$(".draftOrderTmSelInput").empty();
			
			_.each(teams, function(team){
				var optionStart = "<option value=\"";
				var optionMiddle = "\" >";
				var optionEnd = "</option>";
				var selected = "";
				
				if(this.team.get("id") == team.get("id")){
					selected = "\" selected=\"true";
				}
				
				this.$(".draftOrderTmSelInput").append(optionStart 
						+ team.get("id")
						+ selected
						+ optionMiddle
						+ team.get("teamName") + " (" + team.get("draftPosition") + ")"		
						+ optionEnd);				
			}, this);
			
			$(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});
		},
		
		changeTeam: function() {
			var newTeamId = this.$(".draftOrderTmSelInput").val();
			
			if(!newTeamId){
				newTeamId = this.team.get('id');
				this.$(".draftOrderTmSelInput").val(this.team.get('id'));
			}
				
			var newTeam = this.lgInstance.getTeam(newTeamId);
			
			if(newTeam){
				this.pick.set({fantasyTeamId: newTeam.get('id')}, {workingSet: true});
				this.team = newTeam;
				this.$(".draftOrderTmSelInput").val(this.team.get('id'));
			}			
		},
		
		deletePick: function() {
			this.event.trigger("deletePick", this.pick, this.position);
		},
		
		//TODO: Can this be removed?
		updatePosition: function(newPosition){
			this.position = newPosition;
			this.$(".draftOrderPickInfoLabel").html(this.pick.get('round') + '.' + this.position);
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	$(this.el).removeData().unbind();
	    	this.remove();  
	    	Backbone.View.prototype.remove.call(this);
        }
	});
	
	var DraftOrderListAddView = Backbone.View.extend({
		initialize: function(options) {
			this.lgInstance = options.lgInstance;
			this.round = options.round;
			this.event = options.event;
		
			_.bindAll(this, 'addPick');
			
			this.addPickTemplate = _.template(addPickHtml.trim());
			
			this.buildEl();
			
			this.$(".btn").on('click', this.addPick);
		},
		
		render: function () {
			
			return this;
		},
		
		buildEl: function() {
			this.setElement($(this.addPickTemplate({round: this.round})));
		},
		
		addPick: function() {
			this.event.trigger("addPick", this.round);
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	$(this.el).removeData().unbind();
	    	this.remove();  
	    	Backbone.View.prototype.remove.call(this);
        }
	});
	
	var DraftOrderListView = Backbone.View.extend({
		initialize: function(options) {
			this.lgInstance = options.lgInstance;
			this.pickCollection = options.pickCollection;
			this.event = options.event;
			this.submittedData = options.submittedData;
			
			this.pickContainer = $(this.el).find('#draftOrderListContainer');
			this.pickViews = [];
			this.addPickViews = [];
			
			_.bindAll(this, 'addNewPick');
			_.bindAll(this, 'deletePick');
			_.bindAll(this, 'undoPicks');
			_.bindAll(this, 'savePicks');
			_.bindAll(this, 'saveSuccess');
			_.bindAll(this, 'saveError');
			_.bindAll(this, 'fetchSuccess');
			_.bindAll(this, 'fetchError');			
			
			this.listenTo(this.event, 'changeRound', this.renderList);
			this.listenTo(this.event, 'addPick', this.addNewPick);
			this.listenTo(this.event, 'deletePick', this.deletePick);
			this.listenTo(this.event, 'resetPicks', this.resetPicks);
			this.listenTo(this.event, 'undoPicks', this.undoPicks);
			this.listenTo(this.event, 'savePicks', this.savePicks);
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'processing', this.hideAll);
			this.listenTo(this.event, 'error', this.showForm);
			this.listenTo(this.event, 'success', this.showForm);
			
			//this.listenTo(this.pickCollection, 'reset', this.renderList);
			this.listenTo(this.lgInstance, 'change', this.undoPicks);
			this.listenTo(this.lgInstance, 'add:fantasyTeams', this.undoPicks);
			this.listenTo(this.lgInstance, 'remove:fantasyTeams', this.undoPicks);
			this.listenTo(this.lgInstance.get("fantasyTeams"), 'change:draftPosition', this.undoPicks);
		},
		
		render: function () {
			this.renderList();
			
			return this;
		},
		
		renderList: function() {
			this.removeAllPicks();
			this.removeAllAddPicks();
			this.pickContainer.empty();
			this.addAllItems();
		},
		
		removeAllPicks: function() {
			_.each(this.pickViews, function(view, key){
				this.pickViews[key].destroyView();
				delete this.pickViews[key];
			}, this);
		},
		
		removeAllAddPicks: function() {
			_.each(this.addPickViews, function(view, key){
				this.addPickViews[key].destroyView();
				delete this.addPickViews[key];
			}, this);
		},
		
		addFakePickView: function(round, position, lastAddEl) {
			var view = new DraftOrderListFakeItemView({
				lgInstance: this.lgInstance,
				round: round,
				position: position,
				event: this.event});
			$(lastAddEl).before(view.render().el);
			this.pickViews[(round * 1000) + position] = view;
		},
		
		addPickView: function(pick, lastAddEl) {
			var view = new DraftOrderListItemView({
				lgInstance: this.lgInstance,
				pick: pick,
				position: pick.get('posInRound'),
				event: this.event});
			$(lastAddEl).before(view.render().el);
			this.pickViews[(pick.get('round') * 1000) + pick.get('posInRound')] = view;
		},
		
		addAddPickView: function(round) {
			var view = new DraftOrderListAddView({
				lgInstance: this.lgInstance,
				round: round,
				event: this.event});
			this.pickContainer.append(view.render().el);
			this.addPickViews[round] = view;
			
			return view;
		},
		
		addAllItems: function() {
			var round = $(".draftOrderRoundSelInput").val();
			
			if(!round){
				round = 1;
			}
			
			this.lastAddView = this.addAddPickView(round);
			
			if(this.pickCollection.length > 0 && this.lgInstance.get('draftType') == 'CUSTOM'){				
				var foundPicks = this.pickCollection.getPicksByRound(round);
				_.each(foundPicks, function(pick){
					this.addPickView(pick, this.lastAddView.el);
				}, this);				
			} else {
				for (var i=1; i <= this.lgInstance.numTeams(); i++) {
					this.addFakePickView(round, i, this.lastAddView.el);
				}				
			}	
			
			delete this.lastAddView;
		},
		
		addNewPick: function(round) {
			var foundPicks = this.pickCollection.getPicksByRound(round);
			
			var position = foundPicks.length + 1;
			var lastPickTeam = this.lgInstance.getTeamByDraftPosition(1).get('id');
			
			var newPick = new PickModel({
				leagueId : this.lgInstance.get('leagueId'),
				leagueInstanceId : this.lgInstance.get('id'),
				fantasyTeamId : lastPickTeam,
				draftablePlayerId : 0,
				round : round,
				posInRound: position,
				keeper : false,
				autoDrafted : false});	
			this.pickCollection.add(newPick, {workingSet: true});
			
			this.addPickView(newPick, this.addPickViews[round].el);
		},
		
		deletePick: function(deletedPick, position) {
			this.pickViews[(deletedPick.get('round') * 1000) + position].destroyView();
			delete this.pickViews[(deletedPick.get('round') * 1000) + position];
			
			this.deletedPosition = position;
			
			var foundPicks = this.pickCollection.getPicksByRound(deletedPick.get('round'));
			_.each(foundPicks, function(pick, idx){
				var pickPosition = idx + 1;
				if(this.deletedPosition < pickPosition){
					this.pickViews[(pick.get('round') * 1000) + pickPosition -1] = this.pickViews[(pick.get('round') * 1000) + pickPosition];
					delete this.pickViews[(pick.get('round') * 1000) + pickPosition];
					
					this.pickViews[(pick.get('round') * 1000) + pickPosition - 1].updatePosition(pickPosition - 1);
					pick.set({posInRound: (pick.get('posInRound') - 1)}, {workingSet: true});
				}
			}, this);
			
			this.pickCollection.remove(deletedPick);
			
			delete this.deletedPosition;
		},
		
		resetPicks: function(orderType) {
			this.removeAllPicks();
			
			while(this.pickCollection.length > 0){
				this.pickCollection.pop();
			}
			
			var ovrPickNum = 1;
			
			while(ovrPickNum <= (this.lgInstance.numTeams() * this.lgInstance.get('numRounds'))){
				var pickInRound = ovrPickNum % this.lgInstance.numTeams();
				if(pickInRound == 0){
					pickInRound = this.lgInstance.numTeams();
				}
				
				var round = Math.ceil(ovrPickNum / this.lgInstance.numTeams());
				var team = null;
				
				if(orderType == "SNAKE"){
					if(round % 2 == 0){
						//Reverse order
						team = this.lgInstance.getTeamByDraftPosition(this.lgInstance.numTeams() - (pickInRound-1));
					} else {
						//Normal order
						team = this.lgInstance.getTeamByDraftPosition(pickInRound);
					}
				} else if(orderType == "3RR"){
					if(round == 1) {
						//Normal order
						team = this.lgInstance.getTeamByDraftPosition(pickInRound);
					} else if(round == 2 || round == 3){
						//Reverse order
						team = this.lgInstance.getTeamByDraftPosition(this.lgInstance.numTeams() - (pickInRound-1));
					} else if(round % 2 == 0) {
						//Normal order
						team = this.lgInstance.getTeamByDraftPosition(pickInRound);
					} else {
						//Reverse order
						team = this.lgInstance.getTeamByDraftPosition(this.lgInstance.numTeams() - (pickInRound-1));
					}
				} else {
					//Normal order
					team = this.lgInstance.getTeamByDraftPosition(pickInRound);
				}
				
				var newPick = new PickModel({
					leagueId : this.lgInstance.get('leagueId'),
					leagueInstanceId : this.lgInstance.get('id'),
					fantasyTeamId : team.get('id'),
					draftablePlayerId : 0,
					round : round,
					posInRound: pickInRound,
					keeper : false,
					autoDrafted : false});	
				this.pickCollection.add(newPick, {workingSet: true});
				
				ovrPickNum++;
			}
			
			this.renderList();
		},
		
		undoPicks: function() {
			this.event.trigger("processing");
			this.pickCollection.fetch({reset: true, success: this.fetchSuccess, error: this.fetchError});
		},
		
		savePicks: function() {
			if(!this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = true;
				this.event.trigger("processing");
				this.pickCollection.saveChanges(this.saveSuccess, this.saveError);
			}
		},
		
		saveSuccess: function() {
			this.undoPicks();
		},
		
		saveError: function() {
			if(this.submittedData.isSubmitted){
				this.event.trigger("error");
				this.submittedData.isSubmitted = false;
			}
		},
		
		fetchSuccess: function() {
			this.renderList();
			
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				this.event.trigger("success");
			} else {
				this.event.trigger("default");
			}
		},
		
		fetchError: function() {
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
			}
			
			this.event.trigger("error");
		},
		
		hideAll: function () {
			$(this.el).hide();			
		},
		
		showForm: function() {
			this.hideAll();
			
			$(this.el).show();
		},
	    
	    destroyView: function() {
	    	//this.message.destroyView();
	    	
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	var DraftOrderView = Backbone.View.extend({
		el: $("#draftOrderGrp"),
		
		initialize: function(options) {
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.pickCollection = options.pickCollection;
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			this.messageView = new DraftOrderMessageView({el: this.$("#draftOrderMessage"), event: this.event});
			this.footerView = new DraftOrderFooterView({
				el: this.$("#draftOrderFooter"), 
				event: this.event, 
				pickCollection: this.pickCollection,
				lgInstance: this.lgInstance,
				userModel: this.userModel});
			this.resetView = new DraftOrderResetView({
				el: this.$("#draftOrderReset"), 
				event: this.event,
				lgInstance: this.lgInstance,
				userModel: this.userModel});
			this.roundView = new DraftOrderRoundView({el: this.$("#draftOrderRound"), event: this.event, lgInstance: this.lgInstance});
			this.orderView = new DraftOrderListView({
				el: this.$("#draftOrderList"), 
				event: this.event, 
				submittedData : this.submittedData,
				lgInstance: this.lgInstance,
				pickCollection: this.pickCollection});
			this.summaryView = new DraftOrderSummaryView({
				el: this.$("#draftOrderSummary"), 
				event: this.event, 
				lgInstance: this.lgInstance,
				pickCollection: this.pickCollection,
				userModel: this.userModel});
			
			//this.listenTo(this.lgInstance, 'change', this.updateVisuals);
			this.listenTo(this.lgInstance, 'change:draftType', this.updateVisuals);
			
			this.listenTo(this.event, 'default', this.updateVisuals);
			this.listenTo(this.event, 'processing', this.removeCommish);
			this.listenTo(this.event, 'error', this.updateVisuals);
			this.listenTo(this.event, 'success', this.updateVisuals);
		},
		
		render: function () {
			this.updateVisuals();
			
			this.messageView.render();
			this.footerView.render();
			this.resetView.render();
			this.roundView.render();
			this.orderView.render();
			this.summaryView.render();
			
			this.initDefaultView();
			
			return this;
		},
		
		updateVisuals: function() {			
			$(this.el).find('#draftOrderType').show();
			
			if(this.lgInstance.isCommissioner(this.userModel.get('userName')) 
					&& this.lgInstance.get('draftType') == 'CUSTOM' 
					&& this.lgInstance.get('draftStatus') != "COMPLETED"){
				$(this.el).addClass('commish');
			} else {
				$(this.el).removeClass('commish');
			}
			$(this.el).find('#draftOrderTypeLabel').html(this.lgInstance.prettyDraftType());
			
			//this.initDefaultView();
		},
		
		removeCommish: function() {
			$(this.el).removeClass('commish');
			$(this.el).find('#draftOrderType').hide();
		},
		
		initDefaultView: function() {
			this.event.trigger("default");
		}
	    
	    /*destroyView: function() {
	    	this.footerView.destroyView();
	    	this.resetView.destroyView();
	    	this.roundView.destroyView();
	    	this.orderView.destroyView();
	    	
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	//$(this.el).removeData().unbind();
	    	//this.remove();  
	    	//Backbone.View.prototype.remove.call(this);
        }*/
	});
	
	return DraftOrderView;  
});